import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token-H5'
const TokenepayKey = 'epay-Token-H5'
const CompanyId = 'SaasCompanyId'
const versionkey = 'versionkey'
const tskey = 'tskey'
const sasskey = 'sasskey'
const sassiv = 'sassiv'
export function getIV() {
  return Cookies.get(sassiv)
}

export function setIV(iv) {
  return Cookies.set(sassiv, iv)
}

export function removeIV() {
  return Cookies.remove(sassiv)
}
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function getKEY() {
  return Cookies.get(sasskey)
}

export function setKEY(key) {
  return Cookies.set(sasskey, key)
}

export function removekey() {
  return Cookies.remove(sasskey)
}
export function getepayToken() {
  return Cookies.get(TokenepayKey)
}

export function setepayToken(token) {
  return Cookies.set(TokenepayKey, token)
}
export function removeepayToken() {
  return Cookies.remove(TokenepayKey)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function remove() {
  return Cookies.remove(tskey)
}


export function getCompanyId() {
  return Cookies.get(CompanyId)
}
export function setCompanyId(companyid) {
  return Cookies.set(CompanyId, companyid)
}
export function removeCompanyId() {
  return Cookies.remove(CompanyId)
}

export function getts() {
  return Cookies.get(tskey)
}

export function setts(ts) {
  return Cookies.set(tskey, ts)
}

export function removets() {
  return Cookies.remove(tskey)
}

export function getversion() {
  return Cookies.get(versionkey)
}

export function setversion(version) {
  return Cookies.set(versionkey, version)
}

export function removeversion() {
  return Cookies.remove(versionkey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js